



































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Util, getPageAPIs } from "@/common/util";
import PracticeBallSettingAPI from '@/common/api/operationManage/practiceBallSetting';
import { CommonApi } from "@/common/api/common";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import {shareConfirmOptions} from "@/common/config";


export const pageApiList = getPageAPIs(PracticeBallSettingAPI)

const defaultForms = {
  name: '', // 练球名称
  teaching_image: [], // 教学图例
  teaching_video: [], // 教学视频
  describe: '', // 目标
  is_type:null, // 1基础训练 2蛇彩训练
  target_advance: '', // 进阶
  target_elite: '', // 精英
  target_king: '', // 王者
  target_peak: '', // 巅峰
};

const typeList = [
  {
    label: '基础训练',
    value: 1
  },
  {
    label: '蛇彩训练',
    value: 2
  }
]


const typeList2Ch: string[] = typeList.map(item=>item.label)


const coachGiftManageDialogTitle2ch: any = {
  "new-practice-ball-setting": "新增",
  "edit-practice-ball-setting": "编辑",
};



function createVideoItem(fileId: number, url: string) {
  const item = {
    fileId,
    url,
    href: url,
    type: "video/mp4",
    types: "2",
    poster: `${url}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto`,
  };

  return item;
}

@Component({
  components: {

  },
  filters: {
    getTypeName(type: number) {

      return typeList2Ch[type-1] || ''
    }
  }
})
export default class CoachTopicManageList extends Vue {
  private form: any = {
    name: "",
    is_type:0, //类型0全部 1基础训练 2蛇彩训练

  };
  private forms: any = {

  };


  private typeList: any[] = [...typeList]


  private deepLoopUtil: any = {};

  private commonApi: any;

  private practiceBallSetting = new PracticeBallSettingAPI();

  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    this.commonApi = new CommonApi();

  }

  
  private created(): void {
    this.getPracticeBallList();

  }
  private restForm(): void {
    this.form = new Util().clearObject(this.form);
    this.$set(this.form,'is_type',0)
    this.getPracticeBallList();
  }
  //搜索
  private search(): void {
    this.tablePage.page = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getPracticeBallList();
  }

  private tableData: any[] = [];

  private formLabelWidth: string = "100px";
  
  private tablePage: any = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };
  // //翻页
  private handlePageChange(val: any) {
    this.tablePage.page = val.currentPage;
    this.tablePage.prepage = val.pageSize;
    this.getPracticeBallList();
  }

  private addOrUpdateCoachTopicManageTitle: string = "话题信息";

  private dialogFormVisible: boolean = false;


  private upfileList: any[] = []

  // 上传视频
  private upFileloading: boolean = false;
  private handleUploadUserVideo(file: any, fileList: any[]) {

    console.log(file, fileList, "file", "fileList");
    this.upFileloading = true;
    this.commonApi.getOssvideo(
        file instanceof File ? file : file.raw,
        (res: any) => {
          console.log(res, "res 视频上传成功");

          const { data } = res;

          const { data: callbackData } = data;

          const { item: uploadImgObj } = callbackData || {};

          const { id, url } = uploadImgObj;


          this.forms.teaching_video = [createVideoItem(id, url)];
          this.$set(this.forms,'teaching_video',[createVideoItem(id, url)])

          this.upFileloading = false;
        },
        ({ errMsg }: any) => {
          if (errMsg == "out of limit duration") {
            this.$message.error("视频时长不可超过1小时");
          } else {
            this.$message.error("视频上传失败");
          }

          this.upFileloading = false;
        },
        {
          limit_duration: 60 * 60, // 单位 秒  1h
        },
        file.url
    );
  }


  private onFileRemove(file: any) {
    const teaching_video: any[] = this.forms.teaching_video || []

    const existFileIndex = teaching_video.findIndex(
      (eachFile) => eachFile === file || eachFile.fileId == file.fileId || eachFile.url == file.url
    )

    if (existFileIndex > -1) {
      teaching_video.splice(existFileIndex, 1)
      this.$set(this.forms, 'teaching_video', [...teaching_video])
    }
  }
  private handleWakeDialog(mode: string) {

    this.storageLockerDialogMode = mode;
    this.addOrUpdateCoachTopicManageTitle = coachGiftManageDialogTitle2ch[mode] || "话题信息";

    this.initForm(mode);

    this.dialogFormVisible = true;
  }

  private currentPracticeBallSettingItem: any = null;

  private storageLockerDialogMode: string = "";


  private getDetail(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.practiceBallSetting.view({
        id,
      }, 
      (res: any) => resolve((res.data.item || {}) as any),
      (err: any) => reject(err))
    })
  }

  private async initForm(mode: string) {
    const forms: any = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    if (mode == "edit-practice-ball-setting") {
      // 编辑

      const currentPracticeBallSettingItem = this.currentPracticeBallSettingItem;

      const {
        id,
       
      } = currentPracticeBallSettingItem || {};

      const {
        name,
        is_type,
        describe,
        target,
        teaching_image_id,
        teaching_image_url,
        teaching_video_id,
        teaching_video_url
      } = await this.getDetail(id)

      const {
        advance,
        elite,
        king,
        peak
      } = target

      Object.assign(forms, {
        name,
        is_type,
        describe,
        target_advance:advance,
        target_elite:elite,
        target_king:king,
        target_peak:peak,
      })


      const teaching_image = [
        {
          fileId: teaching_image_id,
          url: teaching_image_url
        }
      ]

      forms.teaching_image = teaching_image


      const teaching_video = [
        {
          fileId: teaching_video_id,
          url: teaching_video_url
        }
      ]

      forms.teaching_video = teaching_video

      forms.id = id;
    }

    console.log(forms, "forms");


    this.forms = forms;
  }

  private handleWakeEditPracticeBallSettingDialog(storageLockerItem: any) {
    this.currentPracticeBallSettingItem = storageLockerItem;

    this.handleWakeDialog("edit-practice-ball-setting");
  }

  private handleDelete(item:any):void{
    this.$confirm("确定删除该练球设置吗?", "", {
      ...shareConfirmOptions,
    }).then(() => {
      this.practiceBallSetting.delete(
          {
            id: item.id,
          },
          () => {
            this.getPracticeBallList();
          },
          () => {}
      );
    });
  }


  /** 上传图片方法 */

  private handleUplodUserEffects(file: any, fileList: any[]) {
    this.handleUploadUserMedia(file, fileList, 'teaching_image', "image");
  }

  private async handleUploadUserMedia(
    file: any,
    fileList: any[],
    field: string,
    mode: string
  ) {
    console.log(file, "file");

    function getVideoDuration(url: string): any {
      return new Promise((resolve, reject) => {
        var audio = new Audio(url);
        audio.muted = true;
        audio.play().then(() => audio.pause());
        // 元数据已加载

        const handleLoadedmetadata = function (e: any) {
          // let duration = audio.duration;
          console.log(e, "e audio");
          resolve({
            url,
            duration: audio.duration,
          });

          hanleClearListeners();
        };

        const hanleClearListeners = function () {
          audio.removeEventListener("loadedmetadata", handleLoadedmetadata);
          audio.onerror = null;
        };
        audio.addEventListener("loadedmetadata", handleLoadedmetadata);

        audio.onerror = function (err) {
          reject(err);
        };

        audio.muted = false;
      });
    }

    const forms: any = this.forms;

    const optionList = mode == "image" ? forms[field] : forms.videos;

    const sendMediaApi =
      mode == "image" ? this.commonApi.getOss : this.commonApi.getOssvideo;

    if (mode == "video" && !file.duration) {
      const { duration } = await getVideoDuration(file.url).catch(
        (err: any) => {
          this.$message("获取时长失败");
        }
      );

      file.duration = duration;
    }

    optionList.push(file);

    console.log(forms, "forms");

    this.$set(this.forms, `${field}`, optionList);

    this.changeFilePropByList(file, mode, field, { uploading: true });
    sendMediaApi.call(
      this.commonApi,
      file instanceof File ? file : file.raw,
      (res: any) => {
        console.log(res, "res 图片上传成功");

        const { data } = res;

        const { data: uploadFileObj } = data || {};

        const { item: uploadFile } = uploadFileObj || {};

        const { id, url } = uploadFile;

        // this.$set(this.forms, 'avatar_id', id)
        // this.$set(this.forms, 'avatar', url)
        const changeProps: any = {
          uploading: false,
          fileId: id,
          uploadUrl: url,
        };

        if (file.duration) {
          changeProps.duration = file.duration.toString();
        }

        this.changeFilePropByList(file, mode, field, changeProps);
      },
      () => {
        this.$message.error("图片上传失败");

        this.changeFilePropByList(file, mode, field, {
          uploading: false,
          failed: true,
        });
      }
    );
  }

  private changeFilePropByList(file: any, mode: string, field: string, changes: any = {}) {
    const forms: any = this.forms;

    const setList: any[] = mode == "image" ? forms[field] : forms.videos;
    const existFileIndex = setList.findIndex(
      (each_file: any) => each_file.uid == file.uid
    );

    if (existFileIndex > -1) {
      const originFile = setList[existFileIndex];

      if (Array.isArray(setList)) {
        setList.splice(existFileIndex, 1, Object.assign(originFile, changes));
      }

      this.$set(this.forms, `${field}`, setList);
    }
  }


  private handleFileRemove(file: any, field: string, mode: string) {
    const forms = this.forms;

    const images = mode == "image" ? forms[field] : [];

    const videos = mode == "video" ? forms.videos : [];

    console.log(file, "file");

    const optionList = images.length > 0 ? images : videos;

    const existRemoveFileIndex = optionList.findIndex(
      (each_file: any) => each_file.uid == file.uid
    );

    if (existRemoveFileIndex > -1) {
      optionList.splice(existRemoveFileIndex, 1);

      this.$set(this.forms, `${field}`, optionList);
    }
  }

  // 预览媒体文件
  private previewImages: any[] = [];
  private handlePictureCardPreview(file: any, field: string, mode: string) {
    const forms = this.forms;

    const images = mode == "image" ? forms[field] : [];

    const videos = mode == "video" ? forms.videos : [];

    console.log(file, "file");

    const urls = [
      ...images.map((img: any) => {
        return {
          title: "",
          type: "image/jpeg",
          href: img.url,
          thumbnail: img,
        };
      }),
      ...videos.map((video: any) => {
        return {
          title: "",
          type: "video/mp4",
          href: video.url,
          poster: `${video.url}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto`,
        };
      }),
    ];

    this.previewImages = urls;
  }


  private sumbitCoachTopicManageLoading: boolean = false;


  private handleSumbitCoachTopicManage() {
    const storageLockerDialogMode = this.storageLockerDialogMode;

    const params = this.getCoachTopicManageFormsParams(storageLockerDialogMode);

    console.log(params, "params");
    if (params === false) return;

    this.sumbitCoachTopicManageLoading = true;
    switch (storageLockerDialogMode) {
      case "new-practice-ball-setting":
        this.practiceBallSetting.add(
          params,
          () => {
            this.getPracticeBallList();
            this.dialogFormVisible = false;
            this.sumbitCoachTopicManageLoading = false;
          },
          () => {
            this.sumbitCoachTopicManageLoading = false;
          }
        );
        break;
      case "edit-practice-ball-setting":
        this.practiceBallSetting.update(
          params,
          () => {
            this.getPracticeBallList();
            this.dialogFormVisible = false;
            this.sumbitCoachTopicManageLoading = false;
          },
          () => {
            this.sumbitCoachTopicManageLoading = false;
          }
        );
        break;
    }
  }

  private getCoachTopicManageFormsParams(mode: string) {
    const params: any = {};

    const showErrorMessage = (msg: string) => {
      if (!!msg) {
        this.$message.error(msg);
      }
    };

    const forms = this.forms;

    const {
      id,
      is_type,
      describe,
      target_advance,
      target_elite,
      target_king,
      target_peak,
      teaching_image,
      teaching_video,

    } = forms || {};

    console.log(forms, 'forms')

    Object.assign(params, {
      is_type,
      describe,
      target_advance,
      target_elite,
      target_king,
      target_peak,
    })


    if (!(Array.isArray(teaching_image) && teaching_image.length == 1)) {
      this.$message.error('请上传教学图例')

      return false
    }

    if (teaching_image[0].uploading) {
      this.$message.error('正在上传，请稍等或者删除正在上传的图片')

      return false
    }

    params.teaching_image_id = teaching_image[0].fileId


    if (!(Array.isArray(teaching_video) && teaching_video.length == 1)) {
      this.$message.error('请上传教学视频')

      return false
    }

    if (teaching_video[0].uploading) {
      this.$message.error('正在上传，请稍等或者删除正在上传的视频')

      return false
    }

    params.teaching_video_id = teaching_video[0].fileId

    const keys = ["name"];

    const key2EndKey: any = {
      name: "name",

    };

    const key2ErrMsg: any = {
      name: "练球名称不可为空",
    };

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      if (forms[key]) {
        const errMsg = key2ErrMsg[`${key}_${forms[key]}`];
        if (errMsg) {
          showErrorMessage(errMsg);

          return false;
        }
        params[key2EndKey[key] || key] = forms[key];
      } else {
        showErrorMessage(key2ErrMsg[key]);

        return false;
      }
    }



    if (mode == "edit-practice-ball-setting") {
      params.id = id;
    }

    console.log('params0000',params)

    return params;

  }


  private getPracticeBallList(): void {
    this.practiceBallSetting.getList(
      { ...this.getPracticeBallParams() },
      (res: any) => {

        this.tableData = res.data.list;
        this.tablePage.page = res.data.page;
        this.tablePage.prepage = res.data.prepage;
        this.tablePage.count = res.data.count;
      },
      () => {}
    );
  }

  private getPracticeBallParams(mode = "all"): any {
    const params: any = {};

    const form = this.form;

    const tablePage = this.tablePage;

    const { page, prepage } = tablePage;

    const { name,is_type} = form;

    if (name) {
      params.search_name = name;
    }

     params.is_type = is_type;

     if (
      mode == "exportExcel" &&
      !(params.start_date && params.end_date)
    ) {
      this.$message.error("请选择日期导出数据");
      return null;
    }



    if (mode === "all") {
      params.page = page;

      params.limit = prepage;

    }

    return params;
  }


}
